exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container svg-icon {\n  display: inline-block;\n  height: 32px;\n  min-height: 32px;\n  min-width: 32px;\n  position: relative;\n  width: 32px;\n}\n.container svg-icon svg {\n  display: block;\n  height: 32px;\n  left: 0;\n  min-height: 32px;\n  min-width: 32px;\n  position: absolute;\n  top: 0;\n  width: 32px;\n}\n.container img {\n  background-size: contain;\n  border-radius: 2px;\n  object-fit: cover;\n  object-position: center;\n}\n", ""]);

// exports
